import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';
import { Touch } from 'foundation-sites/js/foundation.util.touch';
import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

Foundation.addToJquery($);
Touch.init($);
Triggers.init($, Foundation);
Foundation.plugin(Reveal, 'Reveal');
